import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { API_BASE_URL } from '../../config';
import styles from './ResumoDespesasEquipePopup.module.css';
import { FiX, FiDollarSign, FiCalendar, FiTruck, FiUsers, FiSearch } from 'react-icons/fi';
import LoadingOverlay from '../../components/LoadingOverlay/LoadingOverlay';

const ResumoDespesasEquipePopup = ({ equipeId, nomeEquipe, dataInicio, dataFim, onClose }) => {
    const [despesas, setDespesas] = useState([]);
    const [loading, setLoading] = useState(true);
    
    const [filtroInicio, setFiltroInicio] = useState(dataInicio);
    const [filtroFim, setFiltroFim] = useState(dataFim);

    const fetchConsolidado = useCallback(async () => {
        setLoading(true);
        try {
            const token = localStorage.getItem('token');
            const response = await axios.get(`${API_BASE_URL}/api/despesas-equipe/consolidado/${equipeId}`, {
                headers: { Authorization: `Bearer ${token}` },
                params: { dataInicio: filtroInicio, dataFim: filtroFim }
            });
            setDespesas(response.data);
        } catch (err) {
            console.error("Erro ao carregar despesas consolidadas", err);
        } finally {
            setLoading(false);
        }
    }, [equipeId, filtroInicio, filtroFim]);

    useEffect(() => {
        fetchConsolidado();
    }, [fetchConsolidado]);

    const totalEquipe = despesas
        .filter(d => d.origem === 'Equipe')
        .reduce((acc, curr) => acc + parseFloat(curr.valor), 0);

    const totalFrota = despesas
        .filter(d => d.origem === 'Frota')
        .reduce((acc, curr) => acc + parseFloat(curr.valor), 0);

    const totalGeral = totalEquipe + totalFrota;

    const formatCurrency = (val) => {
        return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(val);
    };

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        date.setMinutes(date.getMinutes() + date.getTimezoneOffset());
        return date.toLocaleDateString('pt-BR');
    };

    return (
        <div className={styles.overlay}>
            <div className={styles.modal}>
                <header className={styles.header}>
                    <div>
                        <h2>Relatório Financeiro Consolidado</h2>
                        <p>Equipe: <strong>{nomeEquipe}</strong></p>
                    </div>
                    <button onClick={onClose} className={styles.closeBtn}><FiX size={24} /></button>
                </header>

                <div className={styles.filterBar}>
                    <div className={styles.filterGroup}>
                        <FiCalendar />
                        <input 
                            type="date" 
                            value={filtroInicio} 
                            onChange={(e) => setFiltroInicio(e.target.value)} 
                        />
                        <span>até</span>
                        <input 
                            type="date" 
                            value={filtroFim} 
                            onChange={(e) => setFiltroFim(e.target.value)} 
                        />
                    </div>
                    <button className={styles.btnFilter} onClick={fetchConsolidado} disabled={loading}>
                        <FiSearch /> Filtrar Período
                    </button>
                </div>

                {loading ? <div className={styles.loadingSpace}><LoadingOverlay isSmall={true} /></div> : (
                    <div className={styles.body}>
                        <div className={styles.cardsContainer}>
                            <div className={styles.card}>
                                <FiUsers className={styles.iconEquipe} />
                                <div>
                                    <span>Despesas Equipe</span>
                                    <strong>{formatCurrency(totalEquipe)}</strong>
                                </div>
                            </div>
                            <div className={styles.card}>
                                <FiTruck className={styles.iconFrota} />
                                <div>
                                    <span>Despesas Frota</span>
                                    <strong>{formatCurrency(totalFrota)}</strong>
                                </div>
                            </div>
                            <div className={`${styles.card} ${styles.totalCard}`}>
                                <FiDollarSign className={styles.iconTotal} />
                                <div>
                                    <span>Custo Total do Período</span>
                                    <strong>{formatCurrency(totalGeral)}</strong>
                                </div>
                            </div>
                        </div>

                        <div className={styles.tableWrapper}>
                            <table className={styles.table}>
                                <thead>
                                    <tr>
                                        <th>Data</th>
                                        <th>Origem</th>
                                        <th>Tipo / Veículo</th>
                                        <th>Descrição</th>
                                        <th className={styles.textRight}>Valor</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {despesas.map((d, index) => (
                                        <tr key={index} className={d.origem === 'Equipe' ? styles.rowEquipe : styles.rowFrota}>
                                            <td>{formatDate(d.data)}</td>
                                            <td>
                                                <span className={d.origem === 'Equipe' ? styles.badgeEquipe : styles.badgeFrota}>
                                                    {d.origem}
                                                </span>
                                            </td>
                                            <td>
                                                {d.origem === 'Equipe' ? d.tipo_despesa : d.veiculo_modelo}
                                            </td>
                                            <td>{d.descricao}</td>
                                            <td className={styles.textRight}>{formatCurrency(d.valor)}</td>
                                        </tr>
                                    ))}
                                    {despesas.length === 0 && (
                                        <tr>
                                            <td colSpan="5" className={styles.empty}>Nenhum registro encontrado no período.</td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default ResumoDespesasEquipePopup;